// get query param by key
const queryString = ( key ) => {
    key = key.replace(/[*+?^$.\[\]{}()|\\\/]/g, "\\$&")
    var match = location.search.match(new RegExp("[?&]"+key+"=([^&]+)(&|$)"))
    return match && decodeURIComponent(match[1].replace(/\+/g, " "))
}

// get hash parameter (use to detect an amp page)
const getHashParam = ( key ) => {
	const search = window.location.hash;
	const regex = new RegExp("[#&]" + key + "(=([^&]*)|&|$)");
	const results = regex.exec( search );

	if ( !results ) {
		return null;
	}

	if ( !results[2] ) {
		return '';
	}

	return decodeURIComponent( results[2].replace(/\+/g, " ") );
}

// update iframe size
const sendMessage = ( data ) => {
	const iframeId = queryString( 'iframe' );
	let parentDomain = 'globalnews.ca';
	if ( queryString( 'preprod' ) ) {
		parentDomain = 'globalnews-ca-develop.go-vip.net';
	}

	if ( queryString( 'local' ) ) {
		parentDomain = 'local.globalnews.ca';
	}

	const isAmp = getHashParam( 'amp' ) ? true : false;

	try {
		if ( isAmp ) {
			window.parent.postMessage({
			  sentinel: 'amp',
			  type: 'embed-size',
			  height: data.height
			}, '*')
		} else if ( iframeId && parentDomain ) {	
			data['type'] = 'gnca-iframe';
			data['target'] = iframeId;
			window.parent.postMessage( data, 'https://' + parentDomain )
		}
	} catch (e) {
		console.log( e )
	}
}

/**
 * Triggers a function once DOM is loaded, just like $(document).ready()
 *
 * @module utils/dom/DOMReady
 * @param {function} fn - Callback function to be triggered when DOM is ready
 */
const DOMReady = ( fn ) => {
	if ( 'loading' !== document.readyState ) {
		fn();
	} else {
		document.addEventListener( 'DOMContentLoaded', fn );
	}
};


export {
	queryString,
	getHashParam,
	sendMessage,
	DOMReady
}
